// src/geminiClient.js
import { GoogleGenerativeAI } from "@google/generative-ai";
import brokiAgentPrompt from './prompt/brokiAgentPrompt';
import { useSelector } from "react-redux";


const API_KEY = 'AIzaSyAe-zCu2yXFPU32o0949SYoa3hJxQwT2iU' ;

const genAI = new GoogleGenerativeAI(API_KEY);


// Main function
export async function getGeminiResponse(messages, agentPrompt) {
  try {
    const model = genAI.getGenerativeModel({ model: 'gemini-2.0-flash' });

    const chat = model.startChat({
      history: convertToGeminiHistory(messages),
      systemInstruction: {
        role: 'system',
        parts: [{ text: agentPrompt }],
      },
    });

    const lastUserMessage = messages[messages.length - 1].content;

    const result = await chat.sendMessage(lastUserMessage);
    const reply = await result.response.text();

    // 🧠 Check if Gemini has confirmed all details
    const isReadyToSearch = reply.toLowerCase().includes('to confirm') &&
      reply.toLowerCase().includes('sq ft') &&
      reply.toLowerCase().includes('budget');

    if (isReadyToSearch) {
      const criteria = extractListingQuery(reply);
      const matches = await fetchListings(criteria);
      return reply + '\n\n' + matches;
    }

    return reply;
  } catch (error) {
    console.error('Gemini API error:', error);
    return "Sorry, I couldn't fetch a response right now.";
  }
}

function convertToGeminiHistory(messages) {
  const firstUserIndex = messages.findIndex((msg) => msg.role === 'user');
  const trimmed = messages.slice(firstUserIndex);
  return trimmed.map((msg) => ({
    role: msg.role === 'assistant' ? 'model' : 'user',
    parts: [{ text: msg.content }],
  }));
}

function extractListingQuery(text) {
  const sqftMatch = text.match(/(\d{3,4})\s*sq\s*ft/i);
  const locationMatch = text.match(/in\s+(.*?)\s+for/i);
  const budgetMatch = text.match(/budget.*?(\d{2,})\s*[-–to]+\s*(\d{2,})/i);

  return {
    sqft: sqftMatch?.[1] || '',
    location: locationMatch?.[1] || '',
    budgetMin: budgetMatch?.[1] || '',
    budgetMax: budgetMatch?.[2] || '',
  };
}

async function fetchListings({ sqft, location, budgetMin, budgetMax }) {
  try {
    const res = await fetch('https://brokiadmin.com/api/filter-property-list', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        city: location,
        category_id: 1, // Cloud kitchen
        per_page: 5,
        start_price: parseInt(budgetMin),
        end_price: parseInt(budgetMax),
        property_for: 'rent',
      }),
    });

    const json = await res.json();
    const properties = json?.data?.data || [];

    if (properties.length === 0) {
      return "Sorry, no matching cloud kitchens found in that budget and location. Would you like us to notify you when new listings come in?";
    }

    return `Here are a few cloud kitchens you might like:\n\n` + properties.map((p) =>
      `📍 ${p.area}, ${p.city} — ${p.property_size} sq ft @ ₹${p.price}/month`
    ).join('\n');
  } catch (err) {
    console.error('Fetch listings error:', err);
    return "Something went wrong while checking availability. Please try again in a bit.";
  }
}